var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentCorrectChoices)?_c('div',{staticClass:"quiz-selections-component"},_vm._l((_vm.selections),function(selection){return _c('selection-question',{key:selection.es_selectionid,attrs:{"choice":selection,"correctChoices":_vm.filterChoices(selection)}})}),1):_c('Loader')
}
var staticRenderFns = []

export { render, staticRenderFns }